export default __webpack_public_path__ + "static/media/shorelinesThumb.7918d9f7.png";